import React from 'react';
import { FadeInUp, ScaleIn } from './Animations';

const posts = [
  {
    bg: 'linear-gradient(135deg, #1E8449, #27AE60)',
    icon: '🌿', tag: 'Wellness', date: 'July 2026', readTime: '4 min read',
    title: '5 Herbal Remedies That Actually Work for Nigerian Women',
    excerpt: 'Nature has always had the answers. Here are 5 herbal solutions that have transformed the health of thousands across Nigeria.',
  },
  {
    bg: 'linear-gradient(135deg, #C9973A, #E8B84B)',
    icon: '💰', tag: 'Business', date: 'July 2026', readTime: '6 min read',
    title: 'How to Build Multiple Income Streams Starting from Zero',
    excerpt: 'You do not need millions to start. You need a plan, the right mentor, and the courage to begin.',
  },
  {
    bg: 'linear-gradient(135deg, #2471A3, #3498DB)',
    icon: '🏠', tag: 'Real Estate', date: 'July 2026', readTime: '5 min read',
    title: 'Why Real Estate is Still the Smartest Investment in Nigeria',
    excerpt: 'Despite economic uncertainty, property remains one of the most reliable ways to grow and protect your wealth.',
  },
];

export default function Blog() {
  return (
    <section id="blog" style={{
      background: '#fff',
      padding: 'clamp(60px, 8vw, 100px) clamp(20px, 4vw, 52px)',
    }}>
      <div style={{ maxWidth: '1160px', margin: '0 auto' }}>
        <FadeInUp>
          <div style={{ marginBottom: '48px' }}>
            <span style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: '11px', fontWeight: 600, letterSpacing: '4px',
              textTransform: 'uppercase', color: '#C9973A',
              marginBottom: '12px', display: 'block',
            }}>Latest Insights</span>
            <div style={{
              width: '48px', height: '3px',
              background: 'linear-gradient(90deg, #1E8449, #27AE60)',
              marginBottom: '16px', borderRadius: '999px',
            }} />
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: '16px' }}>
              <h2 style={{
                fontFamily: "'Playfair Display', serif",
                fontSize: 'clamp(26px, 4vw, 42px)', fontWeight: 700,
                lineHeight: 1.15, color: '#111827',
              }}>
                Keep Up With <em style={{ fontStyle: 'italic', color: '#1E8449' }}>the Latest</em>
              </h2>
              <a href="/blog" style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: '12px', fontWeight: 600, letterSpacing: '1.5px',
                textTransform: 'uppercase', textDecoration: 'none',
                color: '#1E8449', display: 'flex', alignItems: 'center', gap: '6px',
                padding: '10px 20px', borderRadius: '999px',
                border: '1.5px solid #1E8449',
                transition: 'all 0.25s',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.background = '#1E8449';
                e.currentTarget.style.color = '#fff';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.color = '#1E8449';
              }}
              >View All Posts →</a>
            </div>
          </div>
        </FadeInUp>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '24px',
        }}>
          {posts.map((post, i) => (
            <ScaleIn key={post.title} delay={i * 0.1}>
              <a href="/blog" style={{
                textDecoration: 'none', color: '#111827',
                background: '#fff', borderRadius: '20px',
                overflow: 'hidden', display: 'flex', flexDirection: 'column',
                border: '1px solid #F0F0F0',
                boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                transition: 'transform 0.3s, box-shadow 0.3s',
                height: '100%',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = 'translateY(-6px)';
                e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.1)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.05)';
              }}
              >
                <div style={{
                  height: '160px', background: post.bg,
                  display: 'flex', alignItems: 'center',
                  justifyContent: 'center', fontSize: '44px',
                }}>{post.icon}</div>
                <div style={{ padding: '22px', flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                    <span style={{
                      fontFamily: "'Inter', sans-serif",
                      fontSize: '10px', fontWeight: 700, letterSpacing: '2px',
                      textTransform: 'uppercase', color: '#1E8449',
                    }}>{post.tag}</span>
                    <span style={{
                      fontFamily: "'Inter', sans-serif",
                      fontSize: '11px', color: '#9CA3AF',
                    }}>{post.readTime}</span>
                  </div>
                  <h3 style={{
                    fontFamily: "'Playfair Display', serif",
                    fontSize: '17px', fontWeight: 700,
                    lineHeight: 1.35, marginBottom: '10px', flexGrow: 1,
                  }}>{post.title}</h3>
                  <p style={{
                    fontSize: '13px', lineHeight: 1.65,
                    color: '#6B7280', marginBottom: '16px',
                  }}>{post.excerpt}</p>
                  <div style={{
                    fontFamily: "'Inter', sans-serif",
                    fontSize: '11px', fontWeight: 700, letterSpacing: '1.5px',
                    textTransform: 'uppercase', color: '#1E8449',
                    borderTop: '1px solid #F3F4F6', paddingTop: '12px',
                    display: 'flex', alignItems: 'center', gap: '6px',
                  }}>Read More →</div>
                </div>
              </a>
            </ScaleIn>
          ))}
        </div>
      </div>
    </section>
  );
}
